import Keycloak from 'keycloak-js';

const KEYCLOAK_URL = import.meta.env.VITE_KEYCLOAK_URL ?? 'http://localhost:8080';
const KEYCLOAK_REALM = import.meta.env.VITE_KEYCLOAK_REALM ?? 'vertex';
const KEYCLOAK_CLIENT_ID = import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? 'vertex-hub';

/** Exported so other modules (theme preview, deep links) can build Keycloak URLs. */
export const KEYCLOAK_CONFIG = {
  url: KEYCLOAK_URL,
  realm: KEYCLOAK_REALM,
} as const;

/** Keycloak instance configured for the Vertex Hub */
export const keycloak = new Keycloak({
  url: KEYCLOAK_URL,
  realm: KEYCLOAK_REALM,
  clientId: KEYCLOAK_CLIENT_ID,
});
